import { graphql } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';

export const reorderFolderMutation = graphql(
  `
    mutation ReorderFolder(
      $folderId: String!
      $newParentFolderId: String
      $position: Int!
    ) {
      moveLibraryFolder(
        moveLibraryFolderInput: {
          id: $folderId
          parentFolderId: $newParentFolderId
          position: $position
        }
      ) {
        __typename
        libraryFolder {
          ...Folder
        }
      }
    }
  `,
  [folderFragment],
);
